import { useTheme } from "@hooks";

export const ListBulletPoint = () => {
  const { theme } = useTheme();

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        fill={theme.withdrawal.listItem.background}
      />
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        stroke={theme.withdrawal.listItem.border}
      />
      <rect x="8" y="8" width="8" height="8" rx="4" fill={theme.withdrawal.listItem.fill} />
    </svg>
  );
};
